import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Lab from "@/pages/Lab";
import Intelligence from "@/pages/Intelligence";
import ArticleDetail from "@/pages/ArticleDetail";
import Governance from "@/pages/Governance";
import RequestAccess from "@/pages/RequestAccess";
import Unsubscribe from "@/pages/Unsubscribe";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminConsole from "@/pages/admin/AdminConsole";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  useLenis();
  return (
    <div className="min-h-screen bg-hussar-bg text-hussar-ink">
      <div className="grain-overlay" />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PublicShell><Home /></PublicShell>} />
          <Route path="/lab" element={<PublicShell><Lab /></PublicShell>} />
          <Route path="/intelligence" element={<PublicShell><Intelligence /></PublicShell>} />
          <Route path="/intelligence/:slug" element={<PublicShell><ArticleDetail /></PublicShell>} />
          <Route path="/governance" element={<PublicShell><Governance /></PublicShell>} />
          <Route path="/request-access" element={<PublicShell><RequestAccess /></PublicShell>} />
          <Route path="/unsubscribe" element={<PublicShell><Unsubscribe /></PublicShell>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminConsole />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
